module.exports = __webpack_public_path__ + "static/CP_1-6fb12435c1135af858d972accdb5bd75.png";